/* eslint-disable react/prop-types */
import React from 'react'

import LiveSelect from 'live/components/forms/ui/select'

import { RegularIcon } from '../styles'
import { SelectOptionWithIconClass, SelectValueWithIcon } from '../styles/editor'

const RuleTypeSelector = ({ ruleType, setRuleType }) => (
    <LiveSelect
        noFormGroup
        clearable={false}
        searchable={false}
        options={[
            {
                iconClass: 'far fa-user',
                label: 'User',
                value: 'user'
            },
            {
                iconClass: 'far fa-globe',
                label: 'Global',
                value: 'global'
            }
        ]}
        value={ruleType}
        className="Select-small"
        valueRenderer={option => (
            <SelectValueWithIcon>
                <RegularIcon className={`far fa-${option.value === 'user' ? 'user' : 'globe'}`} />
                <div title={option.label}>{option.label}</div>
            </SelectValueWithIcon>
        )}
        optionComponent={SelectOptionWithIconClass}
        onChange={option => {
            setRuleType(option)
        }}
    />
)

export default RuleTypeSelector
